export default "__VITE_ASSET__DkYcVMny__"